import React, { useContext } from 'react'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import { LanguageContext } from '../i18n/LanguageContext'

function WithNavigate ({ Component, remount }) {
  const navigate = useNavigate()
  const location = useLocation()
  const params = useParams()
  const { language } = useContext(LanguageContext)
  // remount: ogni navigazione (anche verso lo stesso path con un altro state) ricrea la pagina, che legge
  // location.state solo nel costruttore/componentDidMount; evita anche di riusare Nuovo* come Modifica*.
  return <Component key={remount ? location.key : undefined} navigate={navigate} location={location} params={params} language={language} />
}

export default WithNavigate
